import { UserLevel } from 'src/State/User/UserModel'
import { InstallationConfigPUTDto } from '../installation/api'

/** Filters the fields of an installation config and keeps only the ones for a PUT request. */
export const parseInstallationConfigPutPayload = <T extends Partial<InstallationConfigPUTDto>>(
  config: T,
  userLevel: UserLevel | undefined
): Partial<InstallationConfigPUTDto> => {
  const isUser = userLevel === 'USER'

  /** Settings the "USER" level can't change and shouldn't be part of the payload based on AF-5623 */
  const installerAndServiceOnlySettings: Partial<InstallationConfigPUTDto> = {
    eegConnectedPower: config.eegConnectedPower,
    eegDerateAtConnectedPower: config.eegDerateAtConnectedPower,
    eegValue: config.eegValue,
    mainFuse: config.mainFuse,
    mainFuseDerated: config.mainFuseDerated,
    peakPowerPv: config.peakPowerPv,
    phaseCount: config.phaseCount,
    rootPowerMeter: config.rootPowerMeter,
  }

  return {
    coordinateChargingUseCase: config.coordinateChargingUseCase,
    countryCode: config.countryCode,
    emsBatteryBeforeCarMode: config.emsBatteryBeforeCarMode,
    emsBatteryToCarMode: config.emsBatteryToCarMode,
    emsWallboxEnforcePowerAssignment: config.emsWallboxEnforcePowerAssignment,
    emsWeatherRegulatedChargeEnabled: config.emsWeatherRegulatedChargeEnabled,
    phaseImbalance: config.phaseImbalance,
    phaseImbalanceValue: config.phaseImbalanceValue,
    selfconsumptionUseCase: config.selfconsumptionUseCase,
    sgrCooldown: config.sgrCooldown,
    emergencyPowerCheckPartialGridFailure: config.emergencyPowerCheckPartialGridFailure,
    emergencyPowerDelayInSeconds: config.emergencyPowerDelayInSeconds,
    ...(isUser ? {} : installerAndServiceOnlySettings),
  }
}
